import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

// 材料账户列表（按施工员分组汇总）
export const getMaterialAccountLogList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccountLog?` + params,
        method: 'GET'
    })
};

// 材料账户充值
export const rechargeMaterialAccount = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccountLog/recharge`,
        method: 'POST',
        data: data
    })
};

// 材料账户明细（指定施工员的流水明细）
export const getMaterialAccountLogDetail = (userId, params = {}) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccountLog/${userId}?` + params,
        method: 'GET'
    })
};

// 删除材料账户明细（软删除单条流水记录）
export const deleteMaterialAccountLog = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccountLog/${id}`,
        method: 'DELETE'
    })
};

// 远程搜索工程师列表
export const findEngineerUserList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUserList?` + params,
        method: 'GET'
    })
};
